export default __webpack_public_path__ + "static/media/Extra_MassaAmanteigada.e3b8f661.jpg";